import React from 'react';
import { AudioPlayerProvider } from 'react-use-audio-player';
import './src/styles/global.css';

export const wrapRootElement = ({ element }) => {
  return (
    <AudioPlayerProvider>
      {element}
    </AudioPlayerProvider>
  );
};